module.exports = __webpack_public_path__ + "VAGRoundedStd-Light.f11fa33100f5e5e09b97.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.woff2
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.woff2
// module chunks = styles